export default __webpack_public_path__ + "static/SRUS YT75 - Especification Del Producto y Datos Técnicos-adfef1e4ae8a10e0765dc40bfc73f0ef.pdf";